
import { defineComponent } from "vue";
import { playerPageModule } from "@/store/modules/player-page.module";

export default defineComponent({
  computed: {
    name: () => playerPageModule.data.Name
  },
  beforeRouteEnter: async (to, from, next) => {
    await playerPageModule.load(to.params.id as string)
    next()
  },
  unmounted: () => playerPageModule.reset(),
  deactivated: () => playerPageModule.reset()
})

